"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LargeScaleProject = void 0;
const typeorm_1 = require("typeorm");
// eslint-disable-next-line import/no-cycle
const Client_1 = require("../../client/entity/Client");
const JournaledEntity_1 = require("../../JournaledEntity");
// eslint-disable-next-line import/no-cycle
const SupplierLargeScaleProjectAssignment_1 = require("../../supplier/entity/SupplierLargeScaleProjectAssignment");
let LargeScaleProject = class LargeScaleProject extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.LargeScaleProject = LargeScaleProject;
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], LargeScaleProject.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], LargeScaleProject.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Client_1.Client, (c) => c.largeScaleProjects),
    __metadata("design:type", Client_1.Client)
], LargeScaleProject.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => SupplierLargeScaleProjectAssignment_1.SupplierLargeScaleProjectAssignment, (q) => q.largeScaleProject),
    __metadata("design:type", Array)
], LargeScaleProject.prototype, "supplierAssignments", void 0);
exports.LargeScaleProject = LargeScaleProject = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Unique)(['name']),
    __metadata("design:paramtypes", [Object])
], LargeScaleProject);
